export type QoeEventName =
  | "app_interactive"
  | "ws_connected"
  | "ws_reconnected"
  | "timeline_applied"
  | "timeline_rejected"
  | "buffer_level"
  | "stall_started"
  | "stall_ended"
  | "gap_detected"
  | "adapter_switched"
  | "background_transition"
  | "control_submitted"
  | "control_acknowledged"
  | "local_response_applied"
  | "local_response_unavailable";

export interface QoeEvent {
  event: QoeEventName;
  timestamp: string;
  client_instance_id: string;
  session_id?: string;
  timeline_revision?: number;
  control_epoch?: number;
  fields?: Record<string, string | number | boolean | null>;
}

export class TelemetryBuffer {
  readonly #events: QoeEvent[] = [];
  constructor(private readonly clientInstanceId: string, private readonly maxSize = 100) {}

  emit(event: QoeEventName, context: Omit<QoeEvent, "event" | "timestamp" | "client_instance_id"> = {}): void {
    this.#events.push({ event, timestamp: new Date().toISOString(), client_instance_id: this.clientInstanceId, ...context });
    if (this.#events.length > this.maxSize) this.#events.shift();
  }

  drain(): QoeEvent[] {
    return this.#events.splice(0, this.#events.length);
  }
}
